import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const StyledIconCardGrid = styled.section`
  background: #e5e5ff;

  & h2 {
    font-family: Geomanist;
    font-weight: 200;
    font-size: 32px;
    line-height: 42px;
    text-align: center;
    vertical-align: middle;
    color: #000000;
    margin: 2.5rem 0 2rem;
  }

  .grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .grid-item {
      flex: 1 1 calc(100% - 20px);
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 15px;
      justify-content: center;
      min-width: 150px;

      @media ${breakpoints.tablet} {
        flex: 1 1 calc(50% - 20px);
      }

      @media ${breakpoints.desktop} {
        flex: 1 1 calc(33.33% - 20px);
      }

      @media ${breakpoints.desktopLarge} {
        flex: 1 1 calc(25% - 20px);
      }

      & h3 {
        font-family: Geomanist;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        color: #0000ff;
        margin-top: 15px;
      }

      & p {
        font-family: Roboto;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        color: #000;
      }
    }
  }
`;
